(() => {
  const ADD_SELECTOR = 'button[name="add"], input[name="add"]';
  const FORM_SELECTOR = 'form[action*="/cart/add"]';
  const isCroProductPage = () =>
    document.body.classList.contains('pdp-cro-teglie-active') ||
    document.body.classList.contains('pdp-cro-tortakit-active') ||
    Boolean(
      document.querySelector(
        [
          '.product-single--cro-teglie[data-product-handle="tegliefriggitrice"]',
          '.product-single--cro-tortakit[data-product-handle="setdecorazioni"]',
        ].join(', '),
      ),
    );

  const getCheckifyBase = () =>
    document.querySelector('[data-checkify-url]')?.getAttribute(
      'data-checkify-url',
    ) || 'https://pay.checkify.pro';

  const getCookie = (name) => {
    const match = document.cookie.match(
      new RegExp(
        `(?:^|; )${name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1')}=([^;]*)`,
      ),
    );
    return match ? decodeURIComponent(match[1]) : '';
  };

  const redirectToCheckify = () => {
    const base = getCheckifyBase();
    const cartToken = getCookie('cart');
    const storeName = window.Shopify?.shop || '';
    const shopifyS = getCookie('_shopify_s');
    const originUrl = encodeURIComponent(window.location.origin);

    if (!cartToken || !storeName) {
      window.location.assign('/checkout');
      return;
    }

    window.location.href = `${base}/static/html/checkout-redirect.html?storeName=${encodeURIComponent(storeName)}&shopify_s=${encodeURIComponent(shopifyS)}&cartToken=${encodeURIComponent(cartToken)}&originUrl=${originUrl}`;
  };

  const checkoutWithCheckify = async (form) => {
    if (!form.querySelector('[name="quantity"]')) {
      const quantityInput = document.createElement('input');
      quantityInput.type = 'hidden';
      quantityInput.name = 'quantity';
      quantityInput.value = '1';
      form.appendChild(quantityInput);
    }

    await fetch('/cart/clear.js', {
      method: 'POST',
      credentials: 'same-origin',
    });

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      body: new FormData(form),
    });

    if (!response.ok) {
      throw new Error('Unable to add item to cart');
    }

    redirectToCheckify();
  };

  const handleAddClick = (event) => {
    const trigger = event.target.closest(ADD_SELECTOR);
    if (!trigger || trigger.disabled) {
      return;
    }

    if (
      trigger.classList.contains('es-popup-button-overwrite') ||
      trigger.hasAttribute('data-cro-cod-trigger')
    ) {
      return;
    }

    if (trigger.closest('[data-shopify="payment-button"]')) {
      return;
    }

    const form = trigger.closest(FORM_SELECTOR);
    if (!form) {
      return;
    }

    const isCroProduct = isCroProductPage();

    if (isCroProduct && event.type === 'click' && event.defaultPrevented) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    if (!isCroProduct) {
      event.stopImmediatePropagation();
    }

    trigger.disabled = true;
    checkoutWithCheckify(form).catch(() => {
      trigger.disabled = false;
    });
  };

  if (isCroProductPage()) {
    document.addEventListener(
      'touchend',
      (event) => {
        const trigger = event.target.closest(ADD_SELECTOR);
        if (!trigger || trigger.disabled) {
          return;
        }

        if (
          trigger.classList.contains('es-popup-button-overwrite') ||
          trigger.hasAttribute('data-cro-cod-trigger')
        ) {
          return;
        }

        event.preventDefault();
        handleAddClick(event);
      },
      { passive: false },
    );
    document.addEventListener('click', handleAddClick, false);
  } else {
    document.addEventListener('click', handleAddClick, true);
  }
})();
